import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import { Button, Icon } from "@blueprintjs/core";
import FormDrawer from "components/FormDrawer";
import { FormSection } from "components/FormBits";
import { currencySymbol } from "helpers/currency";

const numeral = require("numeral");

const toNumber = (value) => {
  const n = parseFloat(value);
  return isNaN(n) ? null : n;
};

// "$1,234.50", in the invoice's currency when it says, else the account's.
export const formatMoney = (amount, symbol) =>
  `${symbol || currencySymbol()}${numeral(amount || 0).format("0,0.00")}`;

// What's owed on an invoice: total, paid so far, balance. Paid is what the
// invoice summary shows (total - balance). Total and paid are left out when
// the invoice doesn't carry a total (e.g. opened from a list row).
export const PaymentSummary = ({ attributes }) => {
  if (!attributes) return null;
  const symbol = attributes.currency_symbol;
  const total = toNumber(attributes.grand_total);
  const due = toNumber(attributes.due_amount);
  const paid = total !== null && due !== null ? Math.round((total - due) * 100) / 100 : null;
  const cell = { flex: "1 1 0", minWidth: 0 };
  const label = { display: "block", color: "var(--fd-muted)", fontSize: 12, fontWeight: 700 };
  const value = { display: "block", color: "var(--fd-ink)", fontSize: 16, fontWeight: 800, fontVariantNumeric: "tabular-nums" };
  const hasNumber = attributes.number !== undefined && attributes.number !== null && attributes.number !== "";
  return (
    <div style={{ margin: "0 0 18px" }}>
    {hasNumber && <span style={{ ...label, margin: "0 0 6px" }}>Invoice #{attributes.number}</span>}
    <div
      aria-label="What's owed on this invoice"
      role="group"
      style={{
        display: "flex",
        gap: 12,
        padding: "12px 14px",
        border: "1px solid var(--fd-line)",
        borderRadius: 8,
        background: "var(--fd-page)",
      }}
    >
      {total !== null && (
        <div style={cell}>
          <span style={label}>Total</span>
          <span style={value}>{formatMoney(total, symbol)}</span>
        </div>
      )}
      {paid !== null && (
        <div style={cell}>
          <span style={label}>Paid so far</span>
          <span style={value}>{formatMoney(paid, symbol)}</span>
        </div>
      )}
      {due !== null && (
        <div style={cell}>
          <span style={label}>Balance owed</span>
          <span style={{ ...value, color: due > 0 ? "var(--fd-accent)" : "var(--fd-ink)" }}>{formatMoney(due, symbol)}</span>
        </div>
      )}
    </div>
    </div>
  );
};

const optionStyle = {
  display: "flex",
  alignItems: "center",
  gap: 14,
  width: "100%",
  margin: "0 0 10px",
  padding: "14px 16px",
  border: "1px solid var(--fd-line)",
  borderRadius: 10,
  background: "var(--fd-surface)",
  color: "var(--fd-ink)",
  textAlign: "left",
  cursor: "pointer",
};

const PaymentOption = ({ image, title, hint, onClick }) => (
  <button type="button" className="fd-pay-option" style={optionStyle} onClick={onClick}>
    <img src={image} width="44" alt="" />
    <span style={{ flex: "1 1 auto" }}>
      <span style={{ display: "block", fontSize: 15, fontWeight: 800 }}>{title}</span>
      <span style={{ display: "block", color: "var(--fd-muted)", fontSize: 13 }}>{hint}</span>
    </span>
    <Icon icon="chevron-right" />
  </button>
);

@inject("viewStore", "invoiceStore")
@observer
class TransactionModal extends Component {

  handleTransactionDailog() {
    this.props.onClose();
  }

  render() {
    const close = this.handleTransactionDailog.bind(this);
    const chooseCard = () => { this.props.onSuccess("card") };
    const chooseCash = () => { this.props.onSuccess("cash") };
    const object = this.props.invoiceStore.invoice.object;
    const attributes = object && object.attributes;
    return(
      <FormDrawer
        isOpen={this.props.isOpen}
        title="Choose a payment method"
        icon="dollar"
        onClose={close}
        footer={<Button text="Cancel" onClick={close} />}
      >
        <PaymentSummary attributes={attributes} />
        <FormSection title="How are they paying?" hint="Pick one; you'll enter the amount next.">
          <div className="transaction-type">
            <PaymentOption
              image="/mastercard.svg"
              title="Credit card"
              hint="Charge their card now (online, through Stripe)."
              onClick={chooseCard}
            />
            <PaymentOption
              image="/interac-eTransfer.svg"
              title="Cash or Interac"
              hint="They've already paid you; record it on the invoice."
              onClick={chooseCash}
            />
          </div>
        </FormSection>
      </FormDrawer>
    )
  }
}

export default TransactionModal;
